// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBarcodeScanner from "@pace/App/Components/ProductBarcodeScanner/ProductBarcodeScanner";
import * as React from "react";

const enum fields {
    androidAspectRatio = "androidAspectRatio",
    desktopAspectRatio = "desktopAspectRatio",
    iPhoneAspectRatio = "iPhoneAspectRatio",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.androidAspectRatio]: string;
        [fields.desktopAspectRatio]: string;
        [fields.iPhoneAspectRatio]: string;
    };
}

type Props = OwnProps;

interface TestBarCodeAspectRatioStyles {
}

export const testBarCodeAspectRatioStyles: TestBarCodeAspectRatioStyles = {};

const TestBarCodeAspectRatio: React.FC<Props> = ({ fields }) => {
    return (
        <StyledWrapper>
            <ProductBarcodeScanner
                // extendedStyles={styles.scannerStyles}
                // onSearch={(result: string) => searchByScanner(result)}
                // shouldSearchImmediately={isQuickOrder}
                // onClose={() => setIsScannerSearch(false)}
                elementId="testAspectRatio-searchByBarcode"
                androidAspectRatio={fields.androidAspectRatio}
                desktopAspectRatio={fields.desktopAspectRatio}
                iPhoneAspectRatio={fields.iPhoneAspectRatio}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: TestBarCodeAspectRatio,
    definition: {
        group: "Xngage Custom" as any,
        fieldDefinitions: [
            {
                name: "androidAspectRatio",
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: "desktopAspectRatio",
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: "iPhoneAspectRatio",
                fieldType: "Translatable",
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
